import styled, { css } from 'styled-components'
import Modal from 'react-modal'
import { GRAY_SCALE_05, PRIMARY_BLUE_03, PRIMARY_BLUE_05, PRIMARY_BLUE_10, PRIMARY_RED_01 } from 'bd-web-components/src/utils/dash-colors'

interface Exception {
  error: boolean
}

export const StyledModal = styled(Modal)`
  position: absolute;
  inset: 40px;
  border: 1px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255);
  overflow: auto;
  border-radius: 10px;
  outline: none;
  padding: 20px;
  max-width: 524px;
  margin: auto;
  max-height: 410px;
  overflow-y: hidden;
  overflow-x: hidden;
`
export const ConfirmationModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export const ConfirmationModalTitle = styled.h2`
  color: ${PRIMARY_BLUE_03};
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 26.4px;
  margin-bottom: 17px;
  @media(max-width: 762px) {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22.4px;
    margin-bottom: 10px;
  }
`
export const ConfirmationModalSubTitle = styled.h2`
  color: ${GRAY_SCALE_05};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  @media(max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
export const StyledCodeInput = styled(styled.input``) <Exception>`
  color: ${PRIMARY_BLUE_05};
  border: 1px solid ${PRIMARY_BLUE_10};
  background: var(--Branco, #FFF);
  text-align: center;
  width: 65px;
  height: 79px;
  border-radius: 10px;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 26.4px;
  @media(max-width: 580px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    width: 40px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 10px;
  }
  ${props => props.error && css`
    border: 1px solid ${PRIMARY_RED_01};
    color: ${PRIMARY_RED_01};
  `}
`
export const InputBox = styled(styled.div``) <Exception>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: 45px;
  ${props => props.error && css`
    margin-bottom: 0px;
  `}
`
export const CodeBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
`

export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`;

export const ErrorText = styled.p`
  color: ${PRIMARY_RED_01};
  @media(max-width: 762px) {
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 13.6px;
}
`

export const ErrorIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 2px solid red;
  border-radius: 10px;
  margin-right: 11px;
  margin-left: 10px;
`

export const ErrorBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 16px;
  margin-bottom: 16px;
  @media(max-width: 762px) {
    margin-top: 16px;
    margin-bottom: 18px;
  }
`

export const ButtonBox = styled.div`
  display: flex;
  flex-direction: row-reverse;
  @media(max-width: 762px) {
    flex-direction: column;
  }
`

export const Spacer = styled.div`
  width: 17px;
`
